/* global API */

/**
 * Get subjects
 * @returns {Promise} Subjects
 */
export async function useGetSubjects() {
	let baseUrl = `${API.url}/subjects`;

	baseUrl += `?language=${Site.lang_slug}`;

	return fetch(baseUrl, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	})
		.then((res) => res.json())
		.then((response) => {
			this.results.subjects = response.sort((a, b) => {
				const regex = /^(T\d+)/g;

				let aa = a.description.match(regex);
				let bb = b.description.match(regex);

				if (aa && bb) {
					aa = aa[0].replace(/^\D+/g, '');
					bb = bb[0].replace(/^\D+/g, '');

					if (Number(aa) < Number(bb)) {
						return -1;
					}

					if (Number(aa) > Number(bb)) {
						return 1;
					}
				}

				return 0;
			});
		})
		.catch((error) => console.error('Error', error));
}

/**
 * Create subject strings
 * @param {Array} taxonomy Taxonomy terms
 */
export function useCreateSubjectStrings(taxonomy) {
	const subjectArray = [];

	/* Soveltuvuudet ovat kolmessa polvessa (aine, vuosiluokka ja tavoite). Frontissa halutaan sukulaiset yhtenä nippuna (Maantieto, vuosiluokka 7-9, T2), mutta WordPress palauttaa ne luonnollisesti erillään toisistaan. Luodaan siis array, joka sisältää nämä ryhmät objekteina.

	esim.

	soveltuvuudet: [
		[0]: { aine, vuosiluokka, tavoite },
		[1]: { aine, vuosiluokka, tavoite },
	];
	*/

	// Luodaan array, joissa on kaikki pääparentit (parent id 0)
	const parents = taxonomy.filter((term) => term.parent === 0);
	const parentIds = parents.map((parent) => parent.term_id);

	const children = taxonomy.filter((term) => parentIds.includes(term.parent));
	const childIds = children.map((child) => child.term_id);

	let grandchildren = taxonomy.filter((term) => childIds.includes(term.parent));
	const grandchildIds = grandchildren.map((grandchild) => grandchild.term_id);

	let grandgrandchildren = taxonomy.filter((term) => grandchildIds.includes(term.parent));
	const grandgrandchildIds = grandgrandchildren.map((grandgrandchild) => grandgrandchild.term_id);

	const grandgrandgrandchildren = taxonomy.filter((term) => grandgrandchildIds.includes(term.parent));

	let setForDeletion = [];

	if (grandgrandgrandchildren.length > 0) {
		grandgrandgrandchildren.forEach((grandchild) => {
			const obj = {};

			const gcParent = grandgrandchildren.find((parent) => parent.term_id === grandchild.parent);
			const gcGrandparent = grandchildren.find((parent) => parent.term_id === gcParent.parent);
			const gcGrandgrandparent = children.find((parent) => parent.term_id === gcGrandparent.parent);
			const gcGrandgrandgrandparent = parents.find((parent) => parent.term_id === gcGrandgrandparent.parent);

			obj[gcGrandgrandgrandparent.term_id] = gcGrandgrandgrandparent;
			obj[gcGrandgrandparent.term_id] = gcGrandgrandparent;
			obj[gcGrandparent.term_id] = gcGrandparent;
			obj[gcParent.term_id] = gcParent;

			this.formData.soveltuvuudet.push([
				gcGrandgrandgrandparent.term_id,
				gcGrandgrandparent.term_id,
				gcGrandparent.term_id,
				gcParent.term_id,
				grandchild.term_id,
			]);

			const subjectName = gcGrandgrandgrandparent.name;
			const className = gcGrandgrandparent.name;
			const langName = gcGrandparent.name;
			const areaName = gcParent.name;
			const targetName = grandchild.description;

			const subjectString = `${subjectName}, ${className}, ${langName}, ${areaName}, ${targetName}`;

			obj.subject_string = subjectString;

			subjectArray.push(obj);
		});

		setForDeletion.forEach((index) => {
			grandgrandchildren = grandgrandchildren.filter((parent) => parent.term_id !== index);
		});
	}

	setForDeletion = [];

	if (grandgrandchildren.length > 0) {
		grandgrandchildren.forEach((grandchild) => {
			const obj = {};

			const gcParent = grandchildren.find((parent) => parent.term_id === grandchild.parent);
			const gcGrandparent = children.find((parent) => parent.term_id === gcParent.parent);
			const gcGrandgrandparent = parents.find((parent) => parent.term_id === gcGrandparent.parent);

			obj[gcGrandgrandparent.term_id] = gcGrandgrandparent;
			obj[gcGrandparent.term_id] = gcGrandparent;
			obj[gcParent.term_id] = gcParent;

			this.formData.soveltuvuudet.push([
				gcGrandgrandparent.term_id,
				gcGrandparent.term_id,
				gcParent.term_id,
				grandchild.term_id,
			]);

			const subjectName = gcGrandgrandparent.name;
			const className = gcGrandparent.name;
			const areaName = gcParent.name;
			const targetName = grandchild.description;

			const subjectString = `${subjectName}, ${className}, ${areaName}, ${targetName}`;

			setForDeletion.push(grandchild.parent);

			obj.subject_string = subjectString;

			subjectArray.push(obj);
		});

		setForDeletion.forEach((index) => {
			grandchildren = grandchildren.filter((parent) => parent.term_id !== index);
		});
	}

	if (grandchildren.length > 0) {
		grandchildren.forEach((grandchild) => {
			const obj = {};

			const gcParent = children.find((child) => child.term_id === grandchild.parent);
			const gcGrandparent = parents.find((parent) => parent.term_id === gcParent.parent);

			obj[gcGrandparent.term_id] = gcGrandparent;
			obj[gcParent.term_id] = gcParent;
			obj[grandchild.term_id] = grandchild;

			this.formData.soveltuvuudet.push([gcGrandparent.term_id, gcParent.term_id, grandchild.term_id]);

			const subjectName = gcGrandparent.name;
			const className = gcParent.name;
			const targetName = grandchild.description || grandchild.name;

			const subjectString = `${subjectName}, ${className}, ${targetName}`;

			setForDeletion.push(grandchild.parent);

			obj.subject_string = subjectString;

			subjectArray.push(obj);
		});
	}

	this.helpers.subjectArray = subjectArray;
}

/**
 * Set subject select options
 * @param {boolean} array Return the subject target as an array or string
 */
export function useSubjectSelect(array = true) {
	this.helpers.subjectObject.subject_class = '';
	this.helpers.subjectObject.subject_area = '';
	this.helpers.subjectObject.subject_lang = '';

	if (array) {
		this.helpers.subjectObject.subject_target = [];
	} else {
		this.helpers.subjectObject.subject_target = '';
	}
}

/**
 * Set subject select language
 * @param {boolean} array Return the subject target as an array or string
 */
export function useSubjectSelectLang(array = true) {
	this.helpers.subjectObject.subject_area = '';

	if (array) {
		this.helpers.subjectObject.subject_target = [];
	} else {
		this.helpers.subjectObject.subject_target = '';
	}
}

/**
 * Set subject select area
 * @param {boolean} array Return the subject target as an array or string
 */
export function useSubjectSelectArea(array = true) {
	if (array) {
		this.helpers.subjectObject.subject_target = [];
	} else {
		this.helpers.subjectObject.subject_target = '';
	}
}

/**
 * Set subject select target
 * @param {boolean} array Return the subject target as an array or string
 */
export function useSubjectSelectClass(array = true) {
	this.helpers.subjectObject.subject_lang = '';
	this.helpers.subjectObject.subject_area = '';

	if (array) {
		this.helpers.subjectObject.subject_target = [];
	} else {
		this.helpers.subjectObject.subject_target = '';
	}
}

/**
 * Add subject
 */
export function useAddSubject() {
	const sparent = this.helpers.subjectObject.subject;
	const sclass = this.helpers.subjectObject.subject_class;
	const slang = this.helpers.subjectObject.subject_lang;
	const sarea = this.helpers.subjectObject.subject_area;
	const starget = this.helpers.subjectObject.subject_target;

	// Map subjects to array
	const subj = new Map(Object.entries(this.helpers.subjectObject));

	// Subject IDs
	const ids = [];
	subj.forEach((subject) => ids.push(subject.term_id));

	// There is probably a better way to do this, but this works for now
	// Loop all targets
	starget.forEach((target) => {
		const subjectObject = {};

		this.results.subjects.forEach((subject) => {
			if (ids.includes(subject.term_id)) {
				subjectObject[subject.term_id] = subject;

				const alteredSubject = subject;

				if (subject.term_id === starget) {
					const targetArray = alteredSubject.description.split(' ');

					[alteredSubject.name] = targetArray;
				}

				subjectObject[subject.term_id] = alteredSubject;
			}
		});

		// Subject name (e.g. Äidinkieli ja kirjallisuus)
		const subjectName = subjectObject[sparent.term_id].name;

		// Class name (e.g. Vuosiluokat 1-2)
		const className = subjectObject[sclass.term_id].name;

		// Subject string
		let subjectString;

		if (slang) {
			// Subject language exists if subject is Äidinkieli ja kirjallisuus and class is Lukio

			// Language name (e.g. Suomen kieli ja kirjallisuus)
			const langName = subjectObject[slang.term_id].name;

			// Area name (e.g. Tekstien tuottaminen)
			const areaName = subjectObject[sarea.term_id].name;

			subjectString = `${subjectName}, ${className}, ${langName}, ${areaName}`;
		} else if (sarea) {
			const areaName = subjectObject[sarea.term_id].name;

			subjectString = `${subjectName}, ${className}, ${areaName}`;
		} else {
			// In most cases subject string is just subject name and class name (and description of target)
			subjectString = `${subjectName}, ${className}`;
		}

		ids.push(target.term_id);

		// Target description (e.g. T1, T2)
		const targetDesc = target.description;

		subjectString += `, ${targetDesc}`;

		subjectObject.subject_string = subjectString;

		this.helpers.subjectArray.push(subjectObject);
	});

	this.formData.soveltuvuudet.push(ids.filter((id) => id !== undefined));

	const multiselect = document.querySelector('.ops-checkboxes.active');

	if (multiselect) {
		multiselect.style.display = 'none';
	}

	this.helpers.subjectObject = {
		subject: '',
		subject_class: '',
		subject_target: [],
		subject_lang: '',
		subject_area: '',
	};
}

/**
 * Remove subject
 * @param {number} index Index
 */
export function useRemoveSubject(index) {
	this.helpers.subjectArray.splice(index, 1);
	this.formData.soveltuvuudet.splice(index, 1);
}

/**
 * Accept suggestion
 * @param {number} mid Material ID
 */
export function useAcceptSuggestion(mid) {
	this.helpers.showMiniPopup = true;
	this.helpers.suggestionsMessage = '';
	this.helpers.suggestionsLoading = true;

	const body = {
		mid,
		post_id: this.post_id,
	};

	fetch(`${API.url}/subjects/suggestions/accept`, {
		method: 'POST',
		headers: {
			'X-WP-Nonce': API.nonce,
			'Content-Type': 'application/json; charset=utf-8',
		},
		body: JSON.stringify(body),
	})
		.then((res) => res.json())
		.then((response) => {
			this.helpers.suggestionsLoading = false;
			this.helpers.suggestionsMessage = response.message;

			if (response.status === 200) {
				this.formData.suggested_subjects?.splice(this.formData.suggested_subjects?.indexOf(mid), 1);
			}

			setTimeout(() => {
				this.helpers.showMiniPopup = false;
			}, 3000);
		});
}

/**
 * Decline suggestion
 * @param {number} mid Material ID
 */
export function useDeclineSuggestion(mid) {
	this.helpers.showMiniPopup = true;
	this.helpers.suggestionsMessage = '';
	this.helpers.suggestionsLoading = true;

	const body = {
		mid,
		post_id: this.post_id,
	};

	fetch(`${API.url}/subjects/suggestions/decline`, {
		method: 'POST',
		headers: {
			'X-WP-Nonce': API.nonce,
			'Content-Type': 'application/json; charset=utf-8',
		},
		body: JSON.stringify(body),
	})
		.then((res) => res.json())
		.then((response) => {
			this.helpers.suggestionsLoading = false;
			this.helpers.suggestionsMessage = response.message;

			if (response.status === 200) {
				this.formData.suggested_subjects?.splice(this.formData.suggested_subjects?.indexOf(mid), 1);
			}

			setTimeout(() => {
				this.helpers.showMiniPopup = false;
			}, 3000);
		});
}
